import {categoryColor} from 'utils/Helper';

export default theme => ({
  card: {
    paddingBottom: theme.spacing.unit,
  },
  cardContent: {
    border: '1px solid #E0E0E0',
    '-moz-box-shadow': '1px 1px 3px #F5F5F5',
    '-webkit-box-shadow': '1px 1px 3px #F5F5F5',
    boxShadow: '1px 1px 3px #F5F5F5',
    background: '#fff',
    '-moz-border-radius': 2,
    '-webkit-border-radius': 2,
    borderRadius: 2,
    width: '100%',
  },
  content: {
    color: '#424953',
    fontSize: 13,
    lineHeight: 2,
  },
  thumbnail: {
    [theme.breakpoints.up('sm')]: {
      maxHeight: 185
    },
    [theme.breakpoints.only('xs')]: {
      maxHeight: 290,
    }
  },
  thumbnailRoot: {
    width: '100%',
    maxWidth: '100%',
    background: '#fff'
  },
  title: {
    color: props => (props.colorful) ? categoryColor('category', 'primary', 500, '#970b07')(props) : '',
    '& a': {
      color: props => (props.colorful) ? categoryColor('category', 'primary', 500, '#970b07')(props) : '',
    },
    marginBottom: 8,
    fontWeight: '700',
  },
  overTitle: {
    color: '#999',
    lineHeight: 1.7,
    fontWeight: 'normal',
    marginBottom: 5,
    fontSize: 12,
  }
});

